import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Segment, Button, Form, Message, Header, Icon } from 'semantic-ui-react'

import { insertClient } from '../../actions/clientsActions'

import BottomButtons from '../../Shared/BottomButtons'

const usageTip = `Asiakasta käytetään vain kohteiden linkittämiseen ja se näkyy vain ylläpidossa.`

class NewClient extends Component {
    state = { nameValue: '', error: '', loading: false }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        const name = this.state.nameValue
        if (!name) return

        this.props.insertClient(name)
            .catch(err => {
                this.setState({ loading: false, error: err.message })
            })
    }

    render() {
        const { loading, error, nameValue } = this.state
        return (
            <div>
                <Header as="h2" content="Uusi asiakas" />

                <Message
                    info
                    icon="idea"
                    content={usageTip}
                />


                <Segment>
                    <Form error={!!error} onSubmit={this.handleSubmit}>

                        <Form.Input
                            label="Nimi"
                            placeholder="Asiakkaan nimi/tunniste"
                            name="nameValue"
                            value={nameValue}
                            onChange={this.handleChange}
                        />

                        <Message error content={error} />

                        <BottomButtons>
                            <Button primary as={Link} to="/admin/asiakkaat">
                                <Icon name="arrow left" />
                                Takaisin
                                </Button>

                            <Button type="submit" disabled={loading} positive>
                                <Icon name="check" />
                                Luo
                                </Button>
                        </BottomButtons>


                    </Form>

                </Segment>
            </div>
        )
    }
}

const mapStoD = dispatch => {
    return {
        insertClient: client => dispatch(insertClient(client))
    }
}

export default connect(null, mapStoD)(NewClient)


// WEBPACK FOOTER //
// ./src/Admin/Clients/NewClient.js